(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('returnLetterApp')
        .constant('RETURN_LETTER', {
        	'STATE_PAY': 'pay',
            'STATE_LOAN': 'loan',
            'STATE_APS': 'aps',
            'PROCESS_RESULTS': [{code:'1',name:'Điều chỉnh địa chỉ'},
	        	                  {code:'2',name:'Thay đổi địa chỉ'},
	        	                  {code:'3',name:'Địa chỉ không đổi'},
	        	                  {code:'4',name:'Cài CIU'},
	        	                  {code:'5',name:'Đã điều chỉnh trên LAS'},
	        	                  {code:'6',name:'Lưu tại văn phòng'},
	        	                  {code:'7',name:'Lý do khác'}],
          'FORMAT_EXPORT': [{code:'excel',name:'EXCEL'},
    	                    {code:'csv',name:'CSV'}],
	        'PROCESS_RESULTS_VIEW':
			{
				'1': {
					name :'Điều chỉnh địa chỉ',
				},
				'2': {
					name :'Thay đổi địa chỉ',
				},
				'3': {
					name :'Địa chỉ không đổi',
				},
				'4': {
					name :'Cài CIU',
				},
				'5': {
					name :'Đã điều chỉnh trên LAS',
				},
				'6':{
					name :'Lưu tại văn phòng',
				},
				'7': {
					name :'Lý do khác',
				}
			}
        })
})();